import React from "react";

//  Images \\
import newsImage from "../../assets/images/newsImage.svg";

//  Styles \\
import "../../assets/styles/cards/newsCard.scss";

//  Icons \\
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { FaRegHeart } from "react-icons/fa";

const NewsCard = () => {
  return (
    <div>
      <div className="newsCard">
        <div className="card_items">
          <div className="card_items_img">
            <img src={newsImage} alt="newsImage" />
          </div>

          <div className="card_items_content">
            <div className="text">
              <p className="data">Monday 05, September 2021 | By Author</p>
              <p className="title">
                This Article’s Title goes Here, but not too long.
              </p>
            </div>

            <div className="icons">
              <span>
                <MdOutlineRemoveRedEye className="eyeIcon" />
                <p>64</p>
              </span>
              <span>
                <FaRegHeart className="like" />
                <p>82</p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsCard;
